import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;

const handleResponse = (response) => {
  if (response?.data) {
    return response.data;
  }

  return {
    isSuccess: false,
    resultMessage: 'Beklenmeyen cevap alindi.'
  };
};

export async function getPublicTennisAcademyTariffs() {
  try {
    const res = await axios.get(`${baseUrl}/tennis-academy/tariffs/public`);
    return handleResponse(res);
  } catch (error) {
    console.error('[TennisAcademy] public tariffs error', error);
    return {
      isSuccess: false,
      resultMessage: error?.response?.data?.resultMessage || error?.message || 'Tarifeler alinamadi.'
    };
  }
}

export async function initiateTennisAcademyPayment(payload) {
  try {
    const res = await axios.post(`${baseUrl}/tennis-academy/applications/initiate-payment`, payload);
    return handleResponse(res);
  } catch (error) {
    console.error('[TennisAcademy] initiate payment error', error);
    return {
      isSuccess: false,
      resultMessage: error?.response?.data?.resultMessage || error?.message || 'Basvuru baslatilamadi.'
    };
  }
}

export async function checkTennisAcademyMembership(identityNumber) {
  try {
    const res = await axios.get(`${baseUrl}/tennis-academy/applications/check-membership`, {
      params: { identityNumber }
    });
    return handleResponse(res);
  } catch (error) {
    console.error('[TennisAcademy] check membership error', error);
    return {
      isSuccess: false,
      resultMessage: error?.response?.data?.resultMessage || error?.message || 'Uyelik sorgulanamadi.'
    };
  }
}

export async function initiateTennisAcademyRenewal(payload) {
  try {
    const res = await axios.post(`${baseUrl}/tennis-academy/applications/initiate-renewal`, payload);
    return handleResponse(res);
  } catch (error) {
    console.error('[TennisAcademy] initiate renewal error', error);
    return {
      isSuccess: false,
      resultMessage: error?.response?.data?.resultMessage || error?.message || 'Yenileme odemesi baslatilamadi.'
    };
  }
}

export async function initiateTennisAcademyRetrospectivePayment(payload) {
  try {
    const res = await axios.post(`${baseUrl}/tennis-academy/applications/initiate-retrospective-payment`, payload);
    return handleResponse(res);
  } catch (error) {
    console.error('[TennisAcademy] initiate retrospective payment error', error);
    return {
      isSuccess: false,
      resultMessage: error?.response?.data?.resultMessage || error?.message || 'Gecmis donem odemesi baslatilamadi.'
    };
  }
}
